'use strict';

module.exports = function partition(fn) {
  var arrays = [[], []];

  this.items.forEach(function (item) {
    if (fn(item) === true) {
      arrays[0].push(item);
    } else {
      arrays[1].push(item);
    }
  });

  return arrays;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/partition.js
// module id = 274
// module chunks = 0